export {
  TRAINING_TENANT_SLUG,
  isTestAppHost,
  isTestBookingHost,
  isTrainingHost,
  resolveTenantSlug,
  tenantSlugFromHostname,
} from "@shared/tenantSlug";

import { resolveTenantSlug } from "@shared/tenantSlug";

/** Aktueller Mandanten-Slug für API-Aufrufe der Admin-App. */
export function tenantSlug(): string {
  const fromMeta = document
    .querySelector('meta[name="tenant-slug"]')
    ?.getAttribute("content");
  const fromEnv = (import.meta.env.VITE_TENANT_SLUG as string | undefined)?.trim();
  return resolveTenantSlug({ fromMeta, fromEnv });
}
